export const TEST_ID = 'detailsViewCloseButton';
